/* eslint-disable no-use-before-define */
import React from 'react'
import { arrayToggle } from '../../../twd'


export default ({selected, setSelected}) => {
    return <React.Fragment>
    {
        selected.length> 0 && selected.map((a,i)=> (
            <button
                key={i}
                data-name="municipals-market-news-holdings-tag"
                className="tag tag-dismissible"
                onClick={() => {
                    let n = arrayToggle(selected, a)
                    setSelected([...n])
                }}
            >{a.label}
            </button>
        ))
    }
    {
        selected.length === 0 && <div className="text-muted">
            <p>You have no active municipal bond holdings at this time.
            Within Holdings Search, existing positions are accessible within
            the Issuer dropdown - allowing for customized news searches aligned
            with your municipal holdings.</p>
            <p>For more information on municipal bond investing, please reference
            the Municipal Bond Resources module.</p>
        </div>
    }
    </React.Fragment>
}


